import React from 'react';
import { Link } from 'react-router-dom';

const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_a3709e67-7648-4bcb-a123-219697b944ef/artifacts/aqwsfdgh_Martin_Aagaard_-_Kystlandskap_-_IMG_9313.jpg';

export default function EnterPage() {
  return (
    <div className="min-h-screen relative" data-testid="enter-page">
      {/* Background */}
      <div
        className="absolute inset-0 bg-center bg-cover opacity-30"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-[var(--cream)]/80" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="p-6">
          <Link to="/" className="text-lg text-[var(--navy-800)] font-light tracking-widest">
            COASTWISE TRADE
          </Link>
        </header>

        {/* Options */}
        <div className="flex-1 flex items-center justify-center px-6">
          <div className="w-full max-w-sm space-y-4">
            <Link 
              to="/invite" 
              className="btn-big block text-center"
              data-testid="invite-code-button"
            >
              Enter Invite Code
            </Link>
            <Link 
              to="/login" 
              className="btn-big block text-center"
              data-testid="login-button"
            >
              Client Login
            </Link>
            <Link 
              to="/contact" 
              className="btn-big block text-center"
              data-testid="message-button"
            >
              Send a Message
            </Link>

            <div className="pt-6 text-center">
              <Link
                to="/admin/login"
                className="text-xs tracking-widest uppercase text-[var(--muted-foreground)] hover:text-[var(--navy-800)] transition-colors"
                data-testid="admin-access-link"
              >
                Staff Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
